import { useCallback } from 'react';
import { useClient } from 'urql';

import fetchQuery from '@/helper/data-op/fetchQuery';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import {
  JiraIssuesCountDocument,
  JiraIssuesCountQuery,
} from '@/modules/goals/modules/okr/graphql/queries/generated/jiraIssuesCount';
import { PaginatedJiraIssuesPayload } from '@/types/schema';

export default function useSearchJira() {
  const client = useClient();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const searchJira = useCallback(
    async (searchText: string) => {
      const { error, data } = await fetchQuery<JiraIssuesCountQuery>(
        client,
        JiraIssuesCountDocument,
        {
          filters: {
            jqlQuery: searchText,
          },
        },
        {},
      );

      if (error) {
        showDefaultErrorSnackbar();
        return { success: false };
      }

      return {
        success: true,
        jiraIssues: (data as any).jiraIssues as PaginatedJiraIssuesPayload | null,
      };
    },
    [client, showDefaultErrorSnackbar],
  );

  return {
    searchJira,
  };
}
